import { apiClient } from './api-client';

export interface RichTextPresetStyle {
  fontFamily?: string;
  fontSize?: string;
  color?: string;
  backgroundColor?: string;
  bold?: boolean;
  italic?: boolean;
  underline?: boolean;
  blockType?: 'paragraph' | 'heading1' | 'heading2' | 'quote';
  boxEnabled?: boolean;
  boxBackgroundColor?: string;
  boxBorderColor?: string;
  boxTextColor?: string;
  boxPadding?: string;
  boxIconType?: 'vector' | 'emoji';
  boxIcon?: 'none' | 'info' | 'warning' | 'exclamation' | 'check' | 'bell' | 'star';
  boxIconEmoji?: string;
  boxIconColor?: string;
  calloutTone?: 'info' | 'warning' | 'note' | 'custom';
}

export interface RichTextPreset {
  id: string;
  name: string;
  description?: string;
  style: RichTextPresetStyle;
  tenantId: string;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
}

export const richTextPresetsApi = {
  async getPresets() {
    const { data } = await apiClient.get<RichTextPreset[]>('/rich-text-presets');
    return data;
  },

  async createPreset(payload: {
    name: string;
    description?: string;
    style: RichTextPresetStyle;
  }) {
    const { data } = await apiClient.post<RichTextPreset>('/rich-text-presets', payload);
    return data;
  },

  async updatePreset(id: string, payload: {
    name?: string;
    description?: string;
    style?: RichTextPresetStyle;
  }) {
    const { data } = await apiClient.put<RichTextPreset>(`/rich-text-presets/${id}`, payload);
    return data;
  },

  async deletePreset(id: string) {
    const { data } = await apiClient.delete(`/rich-text-presets/${id}`);
    return data;
  },
};
